<template>
    <div>    
        <section class="welcome-one">
			<div class="container">
                <div class="container_row_title">
                    系统列表
                </div>
                <!-- 工业互联网 -->
                <div class="row" v-loading="loading">
                    <div class="col-xl-3 col-lg-12 wow fadeInUp row__item" v-for="(item,index) in solutionList" :key="index"  :data-wow-delay="(index+1)+'ms'" @click="handleDetail(item)">
                        <div style="position: relative; display: block;margin: 10px 0; width: 100%; height: 200px;background: #1748a4;" >
                                <h4 class="row__item_text_title">{{ item.sysName }}</h4>
                    </div>
                    </div>
                </div>
			</div>
		</section>
        <!-- <seek-dialog v-if="seekShow" :title="title"  @close="handleClose"/> -->
    </div>
</template>

<script >
import axios from 'axios';

export default {
    name: 'login',
    components: {
    },
    data () {
        return {
            solutionList: [],
            loading: false
        }
    },
    created() {
        // this.getList()  // 获取内容
    },
    methods: {
        // getList() {
        //     var that = this;
        //     var url = window._address_env_.systemUrl
        //     axios({
        //         method:"GET",
        //         url:url,
        //     }).then(res=>{
        //         if (res.data.success) {
                  
        //             const {result} =res.data
        //             // {
        //             //     "id": "2093234192023109634",
        //             //     "sysName": "焊接云系统V1.0",
        //             //     "sysAddress": "192.168.21.25:3000",
        //             //     "sysIcon": "image/2093236139308433408.png",
        //             //     "enableFlag": "1",
        //             //     "createBy": "admin",
        //             //     "createTime": "2026-08-28 15:08:16",
        //             //     "updateBy": "admin",
        //             //     "updateTime": "2026-08-28 15:16:03",
        //             //     "sysOrgCode": "A01"
        //             // }

        //             that.solutionList = result
                
        //         } else {
        //             that.$message.warning(res.message);
                    
        //         }
        //     });
        // },
        // system.vue
        getList() {
            var that = this;
            var url = window._address_env_.systemUrl
            
            // 显示加载状态
            this.loading = true
            
            axios({
                method: "GET",
                url: url,
            }).then(res => {
                if (res.data.success) {
                    const { result } = res.data
                    // ✅ 确保 result 是数组，防止 undefined
                    that.solutionList = Array.isArray(result) ? result : []
                } else {
                    that.$message.warning(res.message || '获取数据失败')
                    that.solutionList = []  // ✅ 失败时设为空数组
                }
            }).catch(error => {
                let errorMsg = '网络连接失败，请检查网络后重试'
                
                if (error.code === 'ERR_NETWORK') {
                    errorMsg = '无法连接服务器，请检查网络或联系管理员'
                } else if (error.code === 'ECONNABORTED') {
                    errorMsg = '请求超时，请稍后重试'
                } else if (error.response) {
                    errorMsg = `服务器错误: ${error.response.status}`
                }
                
                console.error('获取系统列表失败:', error)
                that.$message.error(errorMsg)
                that.solutionList = []
                that.solutionList = []  // ✅ 错误时设为空数组
            }).finally(() => {
                that.loading = false
            })
        },
        handleDetail(item) {
             // 没有协议则默认加 http://
            const url = item.sysAddress?.startsWith('http') 
                ? item.sysAddress 
                : 'http://' + item.sysAddress;
            window.open(url, '_blank')
        },
    
    }
}
</script>
<style scoped>
.welcome-one {
    background: var(--notech-extra);
    padding: 100px 0 20px; 

    height:calc(100vh - 94px);
    overflow-y: auto;
    box-sizing: border-box; 
}

.row__item {
    cursor: pointer;
    position: relative;
    visibility: visible;
    animation-name: fadeInUp;

}
.col-xl-4 {
    padding: 0;
   
}

.row__item h4 {
    font-size: var(--font-size-24);
    font-weight: bold;
    position: absolute;
    bottom: 0;
    width: 100%;
    line-height: 40px;

    padding: 0 10px;
    box-sizing: border-box;
    left: 0;
    line-height: 30px;
    color: #FFFFFF;
    transition: all 0.6s;
}


.container_row_title{
    font-size: var(--font-size-30);
    text-align: center;
    line-height: 1.65;
    color: var(--notech-black);
}


.row__item_text_title {
    font-size: var(--font-size-24);
    color: var(--notech-white);
}




</style> 
